export function calculateGradientColorHex(d: number): string {
  // this function calculates a hexadecimal color based on an input value that
  // determines the position in a gradient between two colors.
  let green = [57, 233, 127];
  let yellow = [245, 178, 35];
  let red = [250, 58, 67];
  let c1, c2;
  if (d >= 0.5) {
    c2 = green;
    c1 = yellow;
    d = d * 2 - 1;
  } else {
    c1 = yellow;
    c2 = red;
    d = 1 - d * 2;
  }

  let rgb: [number, number, number] = c1.map((p, i) => {
    return Math.floor(c1[i] + d * (c2[i] - c1[i]));
  });
  return rgbToHex(...rgb);
  function rgbToHex(r, g, b) {
    function componentToHex(c) {
      var hex = c.toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    }
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }
}
